/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

angular.module('bulbApp.assetLibraryModule')
.directive('bulbAssetContainer', bulbAssetContainer);

function bulbAssetContainer() {
return {
  restrict: 'E',
  scope: {
    readOnly: '@',
    typeFilter: '@'
  },
  templateUrl: 'ajs/assetlibrary/assetcontainer.html',
  controller: 'AssetContainerController as assetContainerCtrl',
  bindToController: false,
  link: function(scope, element, attrs, assetContainerCtrl) {
    assetContainerCtrl.readOnly = attrs.readOnly === 'true';

    var selectionModal = $(element).closest('bulb-asset-library-use-modal');

    // type filter
    if (attrs.typeFilter) {
      var filter = {
        IMAGE: false,
        VIDEO: false,
        ATTACHED_FILE: false,
        AUDIO: false
      };
      filter[attrs.typeFilter] = true;
      assetContainerCtrl.condition.typeFilter = filter;
    }

    assetContainerCtrl.getEntriesAndUpdateList();

    if (selectionModal) {
      scope.$watch('viewSwitcherService.isTile(assetContainerCtrl.infoType)', function(){
        scope.$emit('viewChanged');
      });
    }

    if (!assetContainerCtrl.readOnly) {
      scope.$watch('viewSwitcherService.isTile(assetContainerCtrl.infoType)', function() {
        assetContainerCtrl.initDraggable();
      });
    }
  }
};
}
